import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../styles.css';

type TSocketProps = {
  text: string;
  onClick: () => void;
};

export const Socket: React.VFC<TSocketProps> = ({ text, onClick }) => {
  return (
    <div className={styles['action_button']} data-name="Socket">
      <UIHeading4 color="text-main-default" onClick={onClick}>
        {text}
      </UIHeading4>
    </div>
  );
};
